<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2022-10-14 16:25:37
-->
<template>
  <span :class="`component__sort-button ${value}`">
    <i class="sort-caret ascending" @click="change('asc')"></i>
    <i class="sort-caret descending" @click="change('desc')"></i
  ></span>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "asc",
    },
  },
  data() {
    return {
      sortRule: this.value,
    };
  },
  watch: {
    value(newValue) {
      this.sortRule = newValue;
    },
    sortRule(newValue) {
      this.$emit("input", newValue);
    },
  },
  methods: {
    change(rule) {
      this.sortRule = rule;
    },
  },
};
</script>

<style lang="scss">
.component__sort-button {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  height: 28px;
  width: 24px;
  vertical-align: middle;
  cursor: pointer;
  overflow: initial;
  position: relative;
  vertical-align: middle;

  i {
    font-style: italic;
  }

  .sort-caret {
    width: 0;
    height: 0;
    border: 5px solid transparent;
    position: absolute;
    left: 7px;
  }

  .sort-caret.ascending {
    border-bottom-color: #c0c4cc;
    top: 3px;
  }

  .sort-caret.descending {
    border-top-color: #c0c4cc;
    bottom: 3px;
  }

  &.desc .sort-caret.descending {
    border-top-color: #409eff;
  }

  &.asc .sort-caret.ascending {
    border-bottom-color: #409eff;
  }
}
</style>